import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions } from '@angular/http';

@Injectable()
export class HttpService extends Http
{
	constructor(backend: XHRBackend, options: RequestOptions)
	{
		options.withCredentials = true;
		options.headers.append('Content-Type', 'application/json');

		super(backend, options);
	}
}



// WEBPACK FOOTER //
// ./src/app/http.service.ts